var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"RouteMap",staticStyle:{"height":"80vh"}},[_c('v-col',{attrs:{"cols":6}},[_c('Map')],1),_c('v-col',{attrs:{"cols":6,"xs12":""}},[_c('Chart')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }